import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import AppBlueprintPicker, { AppBlueprintPickerFieldSchema } from './schema';

export const appBlueprintPickerField = {
  name: 'AppBlueprintPicker',
  component: AppBlueprintPicker,
  schema: AppBlueprintPickerFieldSchema,
};

export const AppBlueprintPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...appBlueprintPickerField,
    schema: AppBlueprintPickerFieldSchema.schema,
  }),
);
